const waitForHydrated = (element: HTMLElement, callback: () => void) => {
    if (element !== null && element !== undefined) {
        if (element.classList.contains("hydrated")) {
            callback();
            return;
        }
        const observer = new MutationObserver((mutations) =>
            mutations.forEach(({ attributeName }) => {
                if (
                    attributeName == "class" &&
                    element.classList.contains("hydrated")
                ) {
                    callback();
                    observer.disconnect();
                }
            })
        );
        observer.observe(element, { attributes: true });
    } else {
        console.warn(
            "WARN: Element passed to waitForHydrated was null, callback called after 1s"
        );
    }
};

export default waitForHydrated;
